import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-card-simple',
    templateUrl: './card-simple.component.html',
    styleUrls: ['./card-simple.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CardSimpleSharedComponent {
    @Input() state;
}
